import React from 'react';
import PropTypes from 'prop-types';

export default function IconAdd({ className, style }) {
  return (
    <svg className={className} fill="none" height="18" style={style} viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.4286 7.39284H10.6071V2.57143C10.6071 1.9798 10.1273 1.5 9.53571 1.5H8.46429C7.87266 1.5 7.39286 1.9798 7.39286 2.57143V7.39284H2.57143C1.9798 7.39284 1.5 7.87264 1.5 8.46427V9.5357C1.5 10.1273 1.9798 10.6071 2.57143 10.6071H7.39286V15.4285C7.39286 16.0202 7.87266 16.5 8.46429 16.5H9.53571C10.1273 16.5 10.6071 16.0202 10.6071 15.4285V10.6071H15.4286C16.0202 10.6071 16.5 10.1273 16.5 9.5357V8.46427C16.5 7.87264 16.0202 7.39284 15.4286 7.39284Z" fill="currentColor"/>
    </svg>
  );
}

IconAdd.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

